import * as React from 'react'
import { ReactElement } from 'react'
import FormContainer from '../../../components/Form/FormContainer'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { Field } from '@fluentui/react-components'
import useAuthorizationGroups from '../../../hooks/useAuthorizationGroups'
import AuthorizationGroupCombobox from '../../Combobox/AuthorizationGroupCombobox'
import UserCombobox from '../../Combobox/UserCombobox'
import { useTranslation } from 'react-i18next'
import { PivotProps } from './FileForm'

export default function AuthorizationPivotItem(props: PivotProps): ReactElement {
    const { t: translate } = useTranslation()
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()
    const { authorizationGroups } = useAuthorizationGroups()

    return (
        <FormContainer>
            {authorizationGroups.length > 0 && (
                <Field label={translate('file.edit.form.authorization.groups')} orientation={props.orientation}>
                    <AuthorizationGroupCombobox
                        multiselect
                        selectedOptions={values.authorization?.groups || []}
                        onOptionSelect={(_, data) => setFieldValue('authorization.groups', data.selectedOptions)}
                    />
                </Field>
            )}
            <Field label={translate('file.edit.form.authorization.individuals')} orientation={props.orientation}>
                <UserCombobox
                    multiselect
                    selectedOptions={values.authorization?.individuals || []}
                    onOptionSelect={(_, data) => setFieldValue('authorization.individuals', data.selectedOptions)}
                />
            </Field>
        </FormContainer>
    )
}
